import { FC } from 'react';

import { BlockWidgetType } from '../../models/Content';
import { getBlockId } from '../../utils/content';
import { ContentBlock } from '../ContentBlock/ContentBlock';
import { BlockWidgetWrapper } from './BlockWidget.styles';
import { BlockWidgetView } from './BlockWidgetView';
import { transformBlockWidget } from './transformers';

type Props = {
    contentItem: BlockWidgetType;
    searchParams?: { [key: string]: string | undefined };
};

export const BlockWidget: FC<Props> = ({ contentItem, searchParams }) => {
    const { type, relatedContent } = transformBlockWidget(contentItem);

    return (
        <BlockWidgetWrapper $hasSectionSpacing={type === 'PlansList'} id={getBlockId(contentItem)}>
            <BlockWidgetView contentItem={contentItem} searchParams={searchParams} />

            {type === 'PlansList' && (
                <>
                    {relatedContent?.map((item) => (
                        <ContentBlock key={item.sys.id} contentItem={item} />
                    ))}
                </>
            )}
        </BlockWidgetWrapper>
    );
};
